<app-header *ngIf="mostrarLayoutSite"></app-header>

<router-outlet></router-outlet>

<app-footer *ngIf="mostrarLayoutSite"></app-footer>
